<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <p-calendar #calendar
    [(ngModel)]="mockValue"
    keepInvalid="true"
    timeOnly="true"
    hourFormat="12"
              appendTo="body"
    (onBlur)="timeHandler('calendar')"
    [inputStyle]="{'height':'30px'}" (onSelect)="timeSelect($event)"
    (focus)="calendarFocus('calendar')" >
  </p-calendar>
</app-generic-field>
